<template>
    <div>
        <buttonlist @help="help" @save="save" @reflash="reflash" ref="SetBtn"></buttonlist>
        <el-button size="mini" type="primary" @click="setEnable(1)" v-if="dataDetail.enable_flag == 0">{{$t('getapi[2557]')}}</el-button>
        <el-button size="mini" type="primary" @click="setEnable(0)" v-if="dataDetail.enable_flag == 1">{{$t('getapi[2572]')}}</el-button>
        <el-tabs :tab-position="'top'" style="margin-top: 5px" v-model="activeName" @tab-click="selectInfo">
            <el-tab-pane :label="$t('getapi[2548]')" name="safeInv">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">

                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[213]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-select filterable multiple v-model="userarr" size="mini" style="width:100%">
                                    <el-option v-for="item in UserInfo" :key="item.Num" :label="item.Name"
                                               :value="item.loginName"></el-option>
                                </el-select>
                                <!--<el-input v-model="dataDetail.mmsgto_list" type="textarea"></el-input>-->
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[225]')" name="safekeep">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">
                                {{$t('getapi[2560]')}}<el-input v-model="dataDetail.cycletime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2559]')}}
                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6413]')" name="fireworks">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">
                                {{$t('getapi[2560]')}}<el-input v-model="dataDetail.cycletime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2559]')}}
                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6414]')" name="safevmi">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">
                                {{$t('getapi[2560]')}}<el-input v-model="dataDetail.cycletime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2559]')}}
                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6415]')" name="stockage">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <span style="color:blue">
                                    {{$t('getapi[6824]')}}
                                </span>
                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6416]')" name="safe_qty">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">

                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <span style="color:blue">
                                    {{$t('getapi[6825]')}}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6417]')" name="mrp_new_so">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px"></td>
                            <td style="width:200px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                            <td style="width:200px">

                            </td>
                            <td style="width:100px">

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6009]')" name="stocklowest">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">

                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[6418]')" name="plan_date">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">

                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12795]')" name="pur_fa">
                <div>
                    <table>
                        <tr>
                            <td colspan="2">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">
                                <span>{{$t('getapi[213]')}}</span>
                            </td>
                            <td style="width:500px">
                                <el-select filterable multiple v-model="userarr" size="mini" style="width:100%">
                                    <el-option v-for="item in UserInfo" :key="item.Num" :label="item.Name"
                                               :value="item.loginName"></el-option>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="2">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td>
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td>
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[12798]')" name="mrp_sendmail">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px"></td>
                            <td style="width:200px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                            <td style="width:200px">

                            </td>
                            <td style="width:100px">

                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[13517]')" name="auto_calc_material">
                <div>
                    <table>
                        <tr>
                            <td colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2552]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:50px">{{$t('getapi[2558]')}}</td>
                            <td style="width:200px">
                                <el-input v-model="dataDetail.leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent style="width:80px"></el-input>{{$t('getapi[2556]')}}
                            </td>
                            <td style="width:200px">

                            </td>
                            <td style="width:100px">
                                <el-checkbox v-model="dataDetail.enable_flag" :true-label="1" :false-label="0" :disabled="true">{{$t('getapi[2557]')}}
                                </el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2555]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.mailto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2554]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.copyto_list" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <span style="color:blue">{{$t('getapi[2553]')}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[213]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-select filterable multiple v-model="userarr" size="mini" style="width:100%">
                                    <el-option v-for="item in UserInfo" :key="item.Num" :label="item.Name"
                                               :value="item.loginName"></el-option>
                                </el-select>
                                <!--<el-input v-model="dataDetail.mmsgto_list" type="textarea"></el-input>-->
                            </td>
                        </tr>
                        <tr>
                            <td  colspan="4">
                                <el-divider content-position="left">{{$t('getapi[2549]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2551]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_title" type="textarea"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[2550]')}}</span>
                            </td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.prior_body" type="textarea"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'remindrule',
        data() {
            return {
                userData: [],
                user: '',
                arr:[],
                dataSet:[],
                dataDetail: {
                    rule_code: 'safeInv',
                    leadtime: 0,
                    leadtime_measure: '',
                    enable_flag: 0,
                    mailto_list: '',
                    copyto_list: '',
                    prior_title: '',
                    prior_body: '',
                    cycletime: 0,
                    readdatadays: 0
                },
                activeName: 'safeInv', // 当前选择的分页
                userarr:'',
                UserInfo: [],
            };
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.getView();
            that.authority();
            that.getAllUser();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[2547]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                that.$refs.SetBtn.SetButtonEnable('save,refresh');
            },
            selectInfo(tab, event) {
                let that = this;
                that.activeName = tab.name
                for(let i = 0;i<that.dataSet.length;i++){
                    if(that.activeName == that.dataSet[i].rule_code){
                        that.dataDetail = that.dataSet[i]
                    }
                }
                that.userarr = []
                if(that.dataDetail.mailto_user){
                    if(that.dataDetail.mailto_user.length > 0){
                        that.userarr = that.dataDetail.mailto_user.split(',')
                    }
                }
            },
            getView() {
                let that = this
                that.$http.urlpost('/Sys/Currency/GetRemindRule', '', function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.list;
                        for(let i = 0;i<that.dataSet.length;i++){
                            if(that.activeName == that.dataSet[i].rule_code){
                                that.dataDetail = that.dataSet[i]
                            }
                        }
                        that.userarr = []
                        if(that.dataDetail.mailto_user){
                            if(that.dataDetail.mailto_user.length > 0){
                                that.userarr = that.dataDetail.mailto_user.split(',')
                            }
                        }
                    }
                });
            },
            reflash(){
                let that = this
                that.getView()
            },
            //启用
            setEnable(val){
                let that = this
                let parm = {
                    rule_code: that.dataDetail.rule_code,
                    enable_flag: val
                }
                that.$http.urlpost('/Sys/Currency/EnableRemindRule', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //保存
            save(){
                let that = this
                let str = ''
                for(let i=0;i<that.userarr.length;i++){
                    str = str + that.userarr[i] + ','
                }
                that.dataDetail.mailto_user = str.substring(0,str.length-1)
                let parm = that.dataDetail
                that.$http.urlpost('/Sys/Currency/SaveRemindRule', parm, function (res) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    that.getView()
                });
            },
            getAllUser(val) {
                let that = this;
                let parm = {

                }
                that.$http.urlpost('/Sys/Currency/GetAllUser', parm, function (res) {
                    if (res.Success == 1) {
                        that.UserInfo = res.DataContent.Table
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-form--inline .el-form-item {
        display: flex;
    }

    .tb-edit .el-input {
        display: none;
    }

    .tb-edit .current-row .el-input {
        display: block;
    }

    .tb-edit .current-row .el-input + span {
        display: none;
    }

    .el-table .hidden-row {
        display: none;
    }
</style>
